<script>
import GraphApexChart from '../../dashboard/GraphApexChart.vue'
export default {
  template: `<div>
              <graph-apex-chart :data='graphBar()'></graph-apex-chart>
             </div>`,
  data(){
    return {
      apex: {
        series: [
          {
            name: 'Es',
            data: [
              {
                x: 'Datos',
                y: 12,
                goals: [
                  {
                    name: 'Deberia ser',
                    value: 14,
                    strokeWidth: 2,
                    strokeDashArray: 2,
                    strokeColor: '#775DD0'
                  }
                ]
              },
            ]
          }
        ],
        options: {
          chart: {
            width: '100%',
            height: '100%',
            redrawOnParentResize: true,
            redrawOnWindowResize: false,
            type: 'bar',
            toolbar: {
              show: false,
            },
            sparkline: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              colors: {
                backgroundBarColors: ['#f9f8f8'],
              },
            },
          },
          colors: ['#d9d2e9'],
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#242732'],
              fontSize: '16px',
            },
            formatter: (val) => val,
          },
          tooltip: {
            enabled: false,
          },
          grid: {
            show: false,
          },
          xaxis: {
            show: false,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          states: {
            hover: {
              filter: {
                type: 'none',
              },
            },
          },
          yaxis: {
            max: 100,
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
        },
        type: 'bar',
      },
      rangos: {
        baja: '#225ea8',
        media: '#4cc488',
        alta: '#fcdd82',
        muyAlta: '#fc8c82'
      },
      params: this.$parent.params
    }
  },
  props: {
    allData: Array
  },
  methods:{
    // Graph
    graphBar() {
      const params = this.params
      const data = params.data
      if (data) {
        let value = data.data
        const values = this.allData.map(e => parseInt(e.data))
        let max = Math.max(...values)

        return {
          series: [
            {
              name: 'Es',
              data: [
                {
                  x: 'Datos',
                  y: value,
                },
              ]
            }
          ],
          options: {
            chart: {
              width: '100%',
              height: '100%',
              redrawOnParentResize: true,
              redrawOnWindowResize: false,
              type: 'bar',
              toolbar: {
                show: false,
              },
              sparkline: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
                colors: {
                  backgroundBarColors: ['#f9f8f8'],
                },
              },
            },
            colors: ['#d9d2e9'],
            dataLabels: {
              enabled: true,
              align: "center",
              offsetY: 4,
              style: {
                colors: ['#242732'],
                fontSize: '15px',
              },
              formatter: (val) => val,
            },
            tooltip: {
              enabled: false,
            },
            grid: {
              show: false,
            },
            xaxis: {
              show: false,
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            states: {
              hover: {
                filter: {
                  type: 'none',
                },
              },
            },
            yaxis: {
              max: max,
              labels: {
                show: false,
              },
              axisBorder: {
                show: false,
              },
            },
          },
          type: 'bar',
        }
      }
    },
  },
  components:{
    GraphApexChart
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frpm/components/graphBar.vue